import React from 'react';
import cn from "./../../../../lib/bem";
import CardSeguroComponent from './../../../../components/cardSeguro/cardSeguro_component';
import ico_test_riesgo from './../../../../assets/svg/ico_test_riesgo.svg';
import ico_devolucion from './../../../../assets/svg/ico_devolucion.svg';
import ico_moneda_creciendo from './../../../../assets/svg/ico_moneda_creciendo.svg';
import ico_historias from './../../../../assets/svg/ico_historias.svg';
import ico_ok from './../../../../assets/svg/ico_ok.svg';
import ico_corazon from './../../../../assets/svg/ico_corazon.svg';

import './seccion_consigues.scss';

const SeccionConsigues = () => {

    const classes = cn("seccionConsigues");

    return ( 
        <div className={classes()}>
            <p className={classes('titleConsigues')}><b>Con este seguro podrás</b></p>
            <div className={classes('seccionConsiguesDiv')}>
                <CardSeguroComponent 
                    ico={ico_test_riesgo}
                    title={'Definir tu inversión'}
                    subTitle={'Desde S/ 20,000 o US$ 7,500 (S/ 27,900).¹'}
                />
                <CardSeguroComponent 
                    ico={ico_moneda_creciendo}
                    title={'Rentabilizar tu dinero'}
                    subTitle={'Tienes el 100% de rentabilidad garantizada.'}
                />
                <CardSeguroComponent 
                    ico={ico_devolucion}
                    title={'Retirar en caso lo necesites'}
                    subTitle={'Puedes retirar tu dinero en cualquier momento de la póliza.'}
                />
            </div>
            <div className={classes('seccionConsiguesDiv')}>
                <CardSeguroComponent 
                    ico={ico_historias}
                    title={'Elegir tus beneficiarios'}
                    subTitle={'Libre elección de beneficiarios sin tener que ser tus herederos legales.'}
                />
                <CardSeguroComponent 
                    ico={ico_ok}
                    title={'Impuestos'}
                    subTitle={'Exoneración del impuesto a la renta sobre las ganancias.²'}
                />
                <CardSeguroComponent 
                    ico={ico_corazon}
                    title={'Seguro de vida'}
                    subTitle={'Cobertura de vida equivalente al 5% de la devolución al finalizar la póliza.'}
                />
            </div>
            <br/><br/>
            <p className={classes('declaimerConsigues')}>1. Tipo de cambio referencial de S/ 3.720. Las primas de seguros de vida emitidas a favor de personas naturales residentes en el Perú están inafectas al IGV.</p>
            <p className={classes('declaimerConsigues')}>2. Las ganancias obtenidas en los seguros de vida se encuentran exoneradas del impuesto a la renta hasta el 31 de diciembre de 2026 de acuerdo con lo dispuesto en el Decreto Supremo N° 179-2004-EF, modificado por el Decreto Legislativo N° 1549. Dicha exoneración se mantendrá vigente en tanto sea renovada.</p>
            <br/>
        </div>
    );
}
 
export default SeccionConsigues;